export default __webpack_public_path__ + "static/about-us-banner-1310-m-94855647d8793654425fc48d4bb0e91d.png";